import {Component, OnChanges, SimpleChanges} from '@angular/core';
import {CapitalCasePipe} from "../../../../pipes/capital-case.pipe";
import {DxButtonComponent, DxDataGridComponent, DxFormComponent, DxTemplateDirective} from "devextreme-angular";
import {
    DxiButtonComponent,
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent, DxoFilterRowComponent, DxoHeaderFilterComponent, DxoLoadPanelComponent, DxoPagerComponent, DxoPagingComponent,
    DxoScrollingComponent, DxoSortingComponent, DxoToolbarComponent
} from "devextreme-angular/ui/nested";
import {UserAvatarEmailComponent} from "../../../../components/utils/user-avatar-email/user-avatar-email.component";
import {TimeOffRequestsComponent} from "../time-off-requests.component";
import {AgencyTimeOffGridViewDto} from "@services";
import {NgClass} from "@angular/common";
import {AgencyTimeOffPopupComponent} from "./agency-time-off-popup/agency-time-off-popup.component";
import {TimeOffFilterPanelComponent} from "../time-off-filter-panel/time-off-filter-panel.component";

@Component({
  selector: 'app-agency-time-offs',
    imports: [
        CapitalCasePipe,
        DxButtonComponent,
        DxDataGridComponent,
        DxTemplateDirective,
        DxiButtonComponent,
        DxiColumnComponent,
        DxiItemComponent,
        DxoColumnChooserComponent,
        DxoExportComponent,
        DxoFilterRowComponent,
        DxoHeaderFilterComponent,
        DxoLoadPanelComponent,
        DxoPagerComponent,
        DxoPagingComponent,
        DxoScrollingComponent,
        DxoSortingComponent,
        DxoToolbarComponent,
        UserAvatarEmailComponent,
        NgClass,
        AgencyTimeOffPopupComponent,
        TimeOffFilterPanelComponent
    ],
  templateUrl: './agency-time-offs.component.html'
})
export class AgencyTimeOffsComponent extends TimeOffRequestsComponent<AgencyTimeOffGridViewDto> implements OnChanges {
    dataSource = this.dataSources.agencyTimeOffs(null);
    filterModel: AgencyTimeOffGridViewDto = new AgencyTimeOffGridViewDto();
    protected override exportName: string = "Agency Time Off";
    protected tabName = 'agency-time-off';

    constructor() {
        super();
        this.init(AgencyTimeOffGridViewDto);
    }

    gridFieldName = (name: keyof AgencyTimeOffGridViewDto): string => name;
    filterModelName = (name: keyof AgencyTimeOffGridViewDto): string => name;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['employeeId']) {
            this.dataSource = this.dataSources.agencyTimeOffs(this.employeeId);
        }
    }

    getCellData(cellInfo: { data: AgencyTimeOffGridViewDto }) {
        return cellInfo.data;
    }

}
